// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeactivateDtaRequestBody
 */
export interface DeactivateDtaRequestBody {
    /**
     * 
     * @type {string}
     * @memberof DeactivateDtaRequestBody
     */
    version?: string;
}

/**
 * Check if a given object implements the DeactivateDtaRequestBody interface.
 */
export function instanceOfDeactivateDtaRequestBody(value: object): value is DeactivateDtaRequestBody {
    return true;
}

export function DeactivateDtaRequestBodyFromJSON(json: any): DeactivateDtaRequestBody {
    return DeactivateDtaRequestBodyFromJSONTyped(json, false);
}

export function DeactivateDtaRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeactivateDtaRequestBody {
    if (json == null) {
        return json;
    }
    return {
        
        'version': json['version'] == null ? undefined : json['version'],
    };
}

export function DeactivateDtaRequestBodyToJSON(json: any): DeactivateDtaRequestBody {
    return DeactivateDtaRequestBodyToJSONTyped(json, false);
}

export function DeactivateDtaRequestBodyToJSONTyped(value?: DeactivateDtaRequestBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'version': value['version'],
    };
}
